import { DashboardOpenMode } from "MyDashboards/state/types";
import Createdashboard from "MyDashboards/views/CreateDashboard/CreateDashboard";
import CreateDashboardToolbar from "components/toolbars/CreateDashboardToolbar";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import React from "react";

const CreateDashboardPage = (mode: DashboardOpenMode) => {
  return (
    <Page Toolbar={CreateDashboardToolbar} mode={DashboardOpenMode.create}>
      <PageContainer width="100%">
        <Createdashboard />
      </PageContainer>
    </Page>
  );
};

export default CreateDashboardPage;
